<template>
  <table class="table-hover reports-table time-off-balances-report-table table">
    <TimeOffBalancesReportTableHeader />

    <tbody>
      <tr>
        <td
          class="time-off-balances-outer"
          colspan="100%"
        >
          <VirtualList
            page-mode
            data-key="uuid"
            :data-component="{}"
            :data-sources="tableData.sections"
            :keeps="30"
            :estimate-size="55"
          >
            <template #item="{ item: section }">
              <table class="table-hover reports-table time-off-balances-report-table table">
                <tbody class="grouping-header">
                  <tr v-if="baseColCount">
                    <th>
                      {{ section.main }}
                    </th>
                    <th
                      v-for="col in colCount"
                      :key="col"
                    ></th>
                  </tr>
                </tbody>

                <tbody class="tbody">
                  <tr
                    v-for="(row, index) in section.rows"
                    :key="`${row.record.id}-${index}`"
                  >
                    <td v-if="walker.sub_show">
                      {{ row.record.sub }}
                    </td>
                    <td>{{ row.record.used | formatDuration(false, '-', false, true) }}</td>
                    <td>{{ row.record.pending | formatDuration(false, '-', false, true) }}</td>
                    <td>{{ row.record.balance | formatDuration(false, '-', false, true) }}</td>
                    <td class="compact-list-cell long-text">
                      <TimeOffBalancesReportManualAdjustments
                        v-if="row.record.manual_adjustments"
                        :manual-adjustments="row.record.manual_adjustments"
                        :members="allMembers"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </VirtualList>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from 'vuex';
import VirtualList from 'vue-virtual-scroll-list';
import TimeOffBalancesReportTableHeader from './TimeOffBalancesReportTableHeader.vue';
import TimeOffBalancesReportManualAdjustments from './TimeOffBalancesReportManualAdjustments.vue';

export default {
  name: 'TimeOffBalancesReportTable',
  components: { VirtualList, TimeOffBalancesReportTableHeader, TimeOffBalancesReportManualAdjustments },
  props: {
    tableData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['walker', 'tableIsTeam', 'allMembers']),
    baseColCount() {
      return this.walker.base_column_count;
    },
    colCount() {
      if (this.tableIsTeam) {
        return this.baseColCount + 1;
      }

      return this.baseColCount;
    },
  },
};
</script>
